const revenueByOverall = (revenues: any) => {
  const result = revenues.reduce((prev: any, curr: any) => prev + curr.net, 0);
  return result;
};

export default revenueByOverall;
